/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CustomerShort } from './CustomerShort';
import {
    CustomerShortFromJSON,
    CustomerShortFromJSONTyped,
    CustomerShortToJSON,
} from './CustomerShort';
import type { Organisation } from './Organisation';
import {
    OrganisationFromJSON,
    OrganisationFromJSONTyped,
    OrganisationToJSON,
} from './Organisation';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './Price';
import type { Product } from './Product';
import {
    ProductFromJSON,
    ProductFromJSONTyped,
    ProductToJSON,
} from './Product';
import type { VoucherStatus } from './VoucherStatus';
import {
    VoucherStatusFromJSON,
    VoucherStatusFromJSONTyped,
    VoucherStatusToJSON,
} from './VoucherStatus';
import type { VoucherType } from './VoucherType';
import {
    VoucherTypeFromJSON,
    VoucherTypeFromJSONTyped,
    VoucherTypeToJSON,
} from './VoucherType';

/**
 * 
 * @export
 * @interface Voucher
 */
export interface Voucher {
    /**
     * 
     * @type {string}
     * @memberof Voucher
     */
    id?: string;
    /**
     * 
     * @type {CustomerShort}
     * @memberof Voucher
     */
    customer?: CustomerShort;
    /**
     * 
     * @type {Organisation}
     * @memberof Voucher
     */
    organisation?: Organisation;
    /**
     * 
     * @type {Product}
     * @memberof Voucher
     */
    product?: Product;
    /**
     * 
     * @type {string}
     * @memberof Voucher
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof Voucher
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof Voucher
     */
    email?: string;
    /**
     * 
     * @type {Price}
     * @memberof Voucher
     */
    value?: Price;
    /**
     * 
     * @type {string}
     * @memberof Voucher
     */
    creator?: string;
    /**
     * 
     * @type {Date}
     * @memberof Voucher
     */
    expirationDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Voucher
     */
    redemptionDate?: Date;
    /**
     * 
     * @type {VoucherStatus}
     * @memberof Voucher
     */
    status?: VoucherStatus;
    /**
     * 
     * @type {VoucherType}
     * @memberof Voucher
     */
    type?: VoucherType;
    /**
     * 
     * @type {boolean}
     * @memberof Voucher
     */
    subscriptionProration?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Voucher
     */
    numPeriodsApplicable?: number;
}

/**
 * Check if a given object implements the Voucher interface.
 */
export function instanceOfVoucher(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VoucherFromJSON(json: any): Voucher {
    return VoucherFromJSONTyped(json, false);
}

export function VoucherFromJSONTyped(json: any, ignoreDiscriminator: boolean): Voucher {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'customer': !exists(json, 'customer') ? undefined : CustomerShortFromJSON(json['customer']),
        'organisation': !exists(json, 'organisation') ? undefined : OrganisationFromJSON(json['organisation']),
        'product': !exists(json, 'product') ? undefined : ProductFromJSON(json['product']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'value': !exists(json, 'value') ? undefined : PriceFromJSON(json['value']),
        'creator': !exists(json, 'creator') ? undefined : json['creator'],
        'expirationDate': !exists(json, 'expirationDate') ? undefined : (new Date(json['expirationDate'])),
        'redemptionDate': !exists(json, 'redemptionDate') ? undefined : (new Date(json['redemptionDate'])),
        'status': !exists(json, 'status') ? undefined : VoucherStatusFromJSON(json['status']),
        'type': !exists(json, 'type') ? undefined : VoucherTypeFromJSON(json['type']),
        'subscriptionProration': !exists(json, 'subscriptionProration') ? undefined : json['subscriptionProration'],
        'numPeriodsApplicable': !exists(json, 'numPeriodsApplicable') ? undefined : json['numPeriodsApplicable'],
    };
}

export function VoucherToJSON(value?: Voucher | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'customer': CustomerShortToJSON(value.customer),
        'organisation': OrganisationToJSON(value.organisation),
        'product': ProductToJSON(value.product),
        'description': value.description,
        'code': value.code,
        'email': value.email,
        'value': PriceToJSON(value.value),
        'creator': value.creator,
        'expirationDate': value.expirationDate === undefined ? undefined : (value.expirationDate.toISOString().substr(0,10)),
        'redemptionDate': value.redemptionDate === undefined ? undefined : (value.redemptionDate.toISOString()),
        'status': VoucherStatusToJSON(value.status),
        'type': VoucherTypeToJSON(value.type),
        'subscriptionProration': value.subscriptionProration,
        'numPeriodsApplicable': value.numPeriodsApplicable,
    };
}

